// extracted by mini-css-extract-plugin
export default {"cBlockToken":"BlockToken_cBlockToken__1W3dt","alignRight":"BlockToken_alignRight__xrv2K","alignCenter":"BlockToken_alignCenter__eAEzE","monospace":"BlockToken_monospace__gFVIi"};